import { render } from "./AddAdminForm.vue?vue&type=template&id=67596764"
import script from "./AddAdminForm.vue?vue&type=script&lang=js"
export * from "./AddAdminForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__